import { useAuth } from "context/userContext";
import React, { useEffect, useState } from "react";
import { BsBuildings } from "react-icons/bs";
import {
    FaBoxes,
    FaBriefcase,
    FaCalendarCheck,
    FaChartBar,
    FaClipboardList,
    FaCogs, FaFileAlt,
    FaMoneyBill,
    FaSignOutAlt,
    FaSitemap, FaTshirt,
    FaUser, FaUsers,
    FaUserTimes,
    FaWallet
} from "react-icons/fa";
import { MdDashboard, MdHolidayVillage } from "react-icons/md";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { SidebarData } from "views/layout/sidebardata";

const MenuPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const [permissions, setPermissions] = useState([]);

  const {
    user,
    userLoading
  } = useSelector((state) => state.user);

  useEffect(() => {
    if (user?.role) {
      setPermissions(user?.role?.permissions.map(item => item.code));
    }
  }, [user]);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const iconMap = {
    Dashboard: <MdDashboard />,
    "Employee Statistics": <FaChartBar />,
    Employees: <FaUser />,
    Holidays: <MdHolidayVillage />,
    "Leave List": <FaCalendarCheck />,
    "Leave View": <FaCalendarCheck />,
    "Leave Planner": <FaCalendarCheck />,
    Payroll: <FaMoneyBill />,
    Expenses: <FaWallet />,
    "Employee Salary": <FaMoneyBill />,
    "Payroll Items": <FaMoneyBill />,
    "Manage Jobs": <FaBriefcase />,
    "Manage Resumes": <FaBriefcase />,
    "Employee referrals": <FaUsers />,
    "Company Directory": <BsBuildings />,
    Documents: <FaFileAlt />,
    Assets: <FaBoxes />,
    Resignation: <FaUserTimes />,
    "Designations": <FaSitemap />,
    "Departments": <FaSitemap />,
    "Grades": <FaSitemap />,
    "Organization Chart": <FaSitemap />,
    "Roles & Permissions": <FaCogs />,
    "Request Approver": <FaCogs />,
    "Uniforms": <FaTshirt />,
    "Assign Uniform": <FaTshirt />,
    "List Allocations": <FaTshirt />,
    "Uniform Stock": <FaTshirt />,
    "User Documents": <FaFileAlt />,
    "Store Documents": <FaFileAlt />,
  };

  const handleNavigation = (route) => {
    if (route.includes("https")) {
      window.open(route, "_blank");
    } else {
      navigate(route);
    }
  };

  const showSubMenu = (menus) => {
    let show = false;
    menus.forEach(menu => {
      if (permissions?.includes(menu?.code)) {
        show = true;
      }
    });
    return show;
  };

  // Categorize menu items into sections
  const categorizeMenuItems = () => {
    const categories = {
      'Overview': [],
      'People': [],
      'Time & Attendance': [],
      'Documents & Assets': [],
      'Finance': [],
      'HR Management': [],
      'Uniform Management': [],
      'Organization': [],
      'Settings': [],
      'External': []
    };

    SidebarData.forEach((item) => {
      const menuValue = item.menuValue?.toLowerCase() || '';
      let hasVisibleContent = false;

      // Check if item or its submenus are visible
      if (item.code && permissions?.includes(item.code)) {
        hasVisibleContent = true;
      } else if (item.hasSubRoute && item.subMenus) {
        hasVisibleContent = item.subMenus.some(subItem =>
          subItem?.code && permissions?.includes(subItem.code)
        );
      }

      if (!hasVisibleContent) return;

      // Overview
      if (menuValue === 'dashboard' || menuValue.includes('employee statistics')) {
        categories['Overview'].push(item);
      }
      // People
      else if (menuValue === 'employees' || menuValue.includes('company directory')) {
        categories['People'].push(item);
      }
      // Time & Attendance
      else if (menuValue.includes('holiday') || menuValue.includes('leave')) {
        categories['Time & Attendance'].push(item);
      }
      // Documents & Assets
      else if (menuValue.includes('document')) {
        categories['Documents & Assets'].push(item);
      }
      else if (menuValue === 'assets') {
        categories['Documents & Assets'].push(item);
      }
      // Finance
      else if (menuValue.includes('expense') || menuValue.includes('payroll')) {
        categories['Finance'].push(item);
      }
      // Uniform Management
      else if (menuValue.includes('uniform')) {
        categories['Uniform Management'].push(item);
      }
      // HR Management
      else if (menuValue.includes('job') || menuValue.includes('resume') || menuValue.includes('referral') ||
        menuValue.includes('resignation')) {
        categories['HR Management'].push(item);
      }
      // Organization
      else if (menuValue.includes('others') || menuValue.includes('designation') ||
        menuValue.includes('department') || menuValue.includes('grade') ||
        menuValue.includes('discount') || menuValue.includes('organization chart')) {
        categories['Organization'].push(item);
      }
      // Settings
      else if (menuValue.includes('setting') || menuValue.includes('role') ||
        menuValue.includes('permission') || menuValue.includes('sync')) {
        categories['Settings'].push(item);
      }
      // External
      else if (menuValue.includes('discount') && !menuValue.includes('organization')) {
        categories['External'].push(item);
      }
    });

    return categories;
  };

  const isMobile = window.innerWidth < 768;

  return (
    <div className="page-wrapper" style={{ paddingBottom: isMobile ? "80px" : "0" }}>
      <div className="content container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-header" style={{ marginBottom: "24px" }}>
              <h3 style={{ fontSize: "24px", fontWeight: "600", color: "#1f2937", margin: 0 }}>
                Menu
              </h3>
            </div>

            <div className="menu-page-grid">
              {Object.entries(categorizeMenuItems()).map(([categoryName, items]) => {
                if (items.length === 0) return null;

                const categoryItems = [];
                items.forEach((item) => {
                  if (!item.hasSubRoute && item?.code && permissions?.includes(item?.code)) {
                    const isOrgChart = item.menuValue === "Organization Chart";
                    categoryItems.push(
                      <div key={item.menuValue} className="menu-page-item" onClick={() => handleNavigation(item.route)} style={{ position: "relative" }}>
                        <div className="menu-page-icon">
                          {iconMap[item.menuValue] || <FaClipboardList />}
                        </div>
                        <span className="menu-page-label">{item.menuValue}</span>
                        {isOrgChart && (
                          <span
                            style={{
                              position: "absolute",
                              top: "8px",
                              right: "8px",
                              background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                              color: "#ffffff",
                              fontSize: "9px",
                              fontWeight: "700",
                              padding: "3px 6px",
                              borderRadius: "10px",
                              lineHeight: "1.2",
                              textTransform: "uppercase",
                              boxShadow: "0 2px 4px rgba(239, 68, 68, 0.3)",
                              border: "1px solid rgba(255, 255, 255, 0.2)",
                            }}
                          >
                            NEW
                          </span>
                        )}
                      </div>
                    );
                  } else if (item.hasSubRoute && item.subMenus) {
                    item.subMenus.forEach((subItem) => {
                      if (subItem?.code && permissions?.includes(subItem?.code)) {
                        const isOrgChart = subItem.menuValue === "Organization Chart";
                        categoryItems.push(
                          <div key={`${subItem.code}-${subItem.menuValue}`} className="menu-page-item" onClick={() => handleNavigation(subItem.route)} style={{ position: "relative" }}>
                            <div className="menu-page-icon">
                              {iconMap[subItem.menuValue] || <FaClipboardList />}
                            </div>
                            <span className="menu-page-label">{subItem.menuValue}</span>
                            {isOrgChart && (
                              <span
                                style={{
                                  position: "absolute",
                                  top: "8px",
                                  right: "8px",
                                  background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                                  color: "#ffffff",
                                  fontSize: "9px",
                                  fontWeight: "700",
                                  padding: "3px 6px",
                                  borderRadius: "10px",
                                  lineHeight: "1.2",
                                  textTransform: "uppercase",
                                  boxShadow: "0 2px 4px rgba(239, 68, 68, 0.3)",
                                  border: "1px solid rgba(255, 255, 255, 0.2)",
                                }}
                              >
                                NEW
                              </span>
                            )}
                          </div>
                        );
                      }
                    });
                  }
                });

                if (categoryItems.length === 0) return null;

                return (
                  <React.Fragment key={categoryName}>
                    <div className="menu-page-section-header">
                      {categoryName}
                    </div>
                    {categoryItems}
                  </React.Fragment>
                );
              })}
              <div className="menu-page-logout-container">
                <button className="menu-page-logout-button" onClick={handleLogout}>
                  <FaSignOutAlt size={18} />
                  <span>Logout</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuPage;

